module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-2.5c1dfe4a.jpg";